export const projectSkills = [
  "Drupal",
  "Twig HTML",
  "SASS/CSS",
  "JavaScript",
  "jQuery",
  "PHP"
];

export const projects = [
  {
    id: 'afs',
    title: "Accenture Federal Services",
    description: 
      "As the nature of this work is confidential, I am unable to show any project visuals for the time being. This website was maintained and redesigned for a federal agency.",
    tools: ["Drupal 10", "Twig HTML", "Sass/CSS", "JavaScript", "PHP", "React"],
    image: "/images/project-afs.png",
  },
  {
    id: 'accordant',
    title: "accordant",
    description: 
      "Nurse care management website built for CVS Health.",
    tools: ["Drupal 8 & 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
    image: "/images/project-accordant.png",
    link: "https://www.accordant.com",
  },
  {
    id: "addventures",
    title: "(add)ventures",
    description: 
      "Corporate website updated and maintained.",
    tools: ["Drupal 8 & 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
    image: "/images/project-addventures.png",
    link: "https://addventures.com",
  },
  {
    id: "cvs-suppliers",
    title: "CVS Suppliers",
    description: 
      "Suppliers website built for CVS Health.",
    tools: ["Drupal 8 & 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
    image: "/images/project-cvs-suppliers.png",
    link: "https://cvssuppliers.com",
  },
  {
    id: "insulet",
    title: "Insulet",
    description:
      "Worked with the Insulet team to export a responsive and accessible menu for their corporate website.",
      tools: ["Drupal 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
      image: "/images/project-insulet.png",
    link: "https://www.insulet.com/",
  },
  {
    id: "cvs-aco",
    title: "CVS ACO",
    description:
      "Accountable Care Organization website built for CVS Health.",
      tools: ["Drupal 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
      image: "/images/project-cvs-aco.png",
  },
  {
    id: "cvs-medicare-fall-forum",
    title: "CVS Medicare Fall Forum",
    description:
      "Medicare Fall Forum website built for CVS Health.",
      tools: ["Drupal 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
    image: "/images/project-cvs-medicare-fall-forum.png",
  },
  {
    id: "cvs-caremark-connections",
    title: "CVS Caremark Connections",
    description:
      "Website built for CVS Caremark.",
      tools: ["Drupal 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
      image: "/images/project-cvs-caremark-connections.png",
    link: "http://caremarkconnections.cvshealth.com",
  },
  {
    id: "omnicare",
    title: "Omnicare",
    description: 
      "Long-term care website built for CVS Health.",
    tools: ["Drupal 8 & 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
    image: "/images/project-omnicare.png",
  },
  {
    id: "encompass-fertility",
    title: "Encompass Fertility",
    description:
      "Fertility website built for CVS Health.",
    tools: ["Drupal 8 & 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
    image: "/images/project-encompass-fertility.png",
  },
  {
    id: "coramhc",
    title: "Coram HC",
    description: 
      "Website for Patients and Caregivers, Providers, and Manufacturers built for CVS Health.",
      tools: ["Drupal 8 & 9", "Twig HTML", "Sass/CSS", "JavaScript/jQuery", "PHP"],
    image: "/images/project-coramhc.png",
    link: "https://www.coramhc.com/",
  },
];

export const skills = [{
  id: "skills",
  skillNames: [    
  "HTML/HTML5",
  "Twig HTML",
  "CSS",
  "Sass",
  "Drupal",
  "JavaScript",
  "jQuery",
  "Bootstrap",
  "PHP",
  "Contentful",
  "React.js",
  "GraphQL",
  "GitHub",
  "Composer",
  "Adobe Photoshop",
  "Adobe XD",
  "Sketch",
  "WAVE",
  "axe DevTools",
  "SiteImprove"]
}];